import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { StandardDivProps } from '@sprinx/react-mui-components/StandardDiv';
import withThemeProps from '@sprinx/react-mui-components/withThemeProps';
import clsx from 'clsx';
import React from 'react';
import { useRecoilValue } from 'recoil';
import { ProductDetailProduct } from '../../../api/products/productDetail';
import { isAuthenticatedState } from '../../../api/appState';
import { showStockAvailability } from '../../../config';
import ProductDetailAddToCart from './ProductDetailAddToCart';
import ProductDetailName from './ProductDetailName';
import ProductDetailPrice from './ProductDetailPrice';
import ProductDetailStockInfo from './ProductDetailStockInfo';

export interface ProductDetailVariantRowProps extends StandardDivProps<ProductDetailVariantRowClassKey> {
  product: ProductDetailProduct;
}

export type ProductDetailVariantRowClassKey =
  | 'root'
  | 'name'
  | 'addToCart'
  | 'price'
  | 'stockInfo'
  // | 'parameters'
  | 'productType';

const themeSettings = { name: 'ProductDetailVariantRow' };
const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles<ProductDetailVariantRowClassKey, {}>({
      root: {
        display: 'grid',
        gridTemplateColumns: '150px 1fr 1fr 250px',
        gridTemplateAreas: `
        "name         name         name     stockInfo"
        "price        price        price    addToCart"
        `,
        [theme.breakpoints.down('xs')]: {
          gridTemplateColumns: '130px 1fr',
          gridTemplateAreas: `
            "name         name"
            "price        price"
            "stockInfo    addToCart"
          `,
          padding: theme.spacing(1, 0),
        },
      },
      name: {
        gridArea: 'name',
        '& > h1': { fontSize: 18 },
      },
      addToCart: {
        gridArea: 'addToCart',
        [theme.breakpoints.down('xs')]: {
          justifyContent: 'flex-end',
        },
      },
      price: {
        gridArea: 'price',
        justifyContent: 'space-around',
      },
      stockInfo: {
        gridArea: 'stockInfo',
        alignItems: 'center',
        paddingBottom: 0,
        [theme.breakpoints.down('xs')]: {
          justifyContent: 'flex-start',
        },
      },
      // parameters: {
      //   gridArea: 'parameters',
      //   display: 'flex',
      // },
      productType: {
        marginLeft: theme.spacing(2),
      },
    }),
  themeSettings,
);

const ProductDetailVariantRow = React.forwardRef<HTMLDivElement, ProductDetailVariantRowProps>(
  ({ className, classes: pClasses, product }, ref) => {
    const classes = useStyles({ classes: pClasses });
    const isAuthenticated = useRecoilValue(isAuthenticatedState);

    return (
      <div ref={ref} className={clsx(classes.root, className)}>
        <ProductDetailName className={classes.name} product={product} />
        {/* <ProductDetailParameters className={classes.parameters} product={product} /> */}
        {showStockAvailability && isAuthenticated && (
          <ProductDetailStockInfo className={classes.stockInfo} product={product} />
        )}
        <ProductDetailPrice className={classes.price} product={product} />
        {isAuthenticated && <ProductDetailAddToCart className={classes.addToCart} product={product} />}
      </div>
    );
  },
);

ProductDetailVariantRow.displayName = 'ProductDetailVariantRow';

export default withThemeProps(themeSettings)(ProductDetailVariantRow);

// const ProductDetailParameters: React.FC<ProductDetailVariantRowProps> = ({ product, className }) => {
//   const t = useTranslateWithFallback();
//   return (
//     <div className={className}>
//       <TextFieldPreview label={t('common/code')} value={product.sku || ''} size='small' />
//       <NumberFieldPreview
//         label={t('productPage/minOrderableQuantity')}
//         value={product.quantityStep}
//         size='small'
//         decimalPrecision={0}
//       />
//       <TextFieldPreview label={t('common/unit')} value={product.unit} size='small'  />
//     </div>
//   );
// };
